<ion-item lines="none" class="year-slider-item">

  <yu-icon
    slot="start"
    name="caret-left"
    color="dark"
    (click)="subtractYear()"
  ></yu-icon>

  <ion-label (click)="openModalYear()">
    {{ fromDate | date: "yyyy" }}
  </ion-label>

  <yu-icon
    slot="end"
    name="caret-right"
    color="dark"
    (click)="addYear()"
  ></yu-icon>

</ion-item>
